






































































































































































































































/*
todo:
- sort by number of new messages (only if involved), then by the latest message,
- add current case id to url (for page reloads)
*/

import axios from 'axios'
import Vue from 'vue'
import marked from 'marked'
import keyBy from 'lodash/keyBy'
import orderBy from 'lodash/orderBy'
import cloneDeep from 'lodash/cloneDeep'

import AuthorizationMixin from '@/routing/AuthorizationMixin'

import {
  MessageNodeFragment,
  CaseListWithMessageCountsQuery,
  CaseListWithMessageCountsQueryVariables,
  CaseWithMessagesQuery,
  CaseWithMessagesQueryVariables,
  UpdateCaseMessageMutationVariables,
  UpdateNewMessagesOfterOfInvolvementMutationVariables,
  DeleteCaseMessageByIdMutationVariables,
  UpdateFavoriteMessageMutationVariables,
} from '@/graphql-schema'

import {
  CaseListWithMessageCounts,
  CaseWithMessages,
  UpdateCaseMessageById,
  UpdateNewMessagesOfterOfInvolvement,
  UpdateFavoriteMessageOfInvolvement,
  DeleteCaseMessageById,
} from '@/queries/cases.graphql'
import { Message } from '@/interfaces'

export interface MyMessageData {
  id: string
  short_id: number
  messagecount: number | 0
  last_sent_date: string | null
  title: string | null
  alias: string | null
  username: string | null
  email: string | null
  stage: string | null
  favorite_message: boolean | false
}

type PickedCase = CaseWithMessagesQuery['pickedCase']
type ShortCase = NonNullable<CaseListWithMessageCountsQuery['cases']>['nodes'][0]

export interface Data {
  //cases: CaseListWithMessageCountsQuery['cases']
  myMessages: MyMessageData[]
  editableMessages: { [k: string]: MessageNodeFragment }
  filterStage: string
  pickedCase: PickedCase | null
  pickedCaseId: string | null
  search: string
  pageSize: number
  page: number
  filterUnreadFavorites: boolean,
  selectedTarget: string | null
}

interface AddressableRoles {
  interviewers?: boolean | null
  patients?: boolean | null
  supervisors?: boolean | null
  supporters?: boolean | null
  therapists?: boolean | null
  counselors?: boolean | null
}

export default Vue.extend({
  mixins: [AuthorizationMixin],
  data(): Data {
    return {
      //cases: { nodes: [] },
      myMessages: [],
      editableMessages: {},
      selectedTarget: '',
      filterStage: '',
      pageSize: 200,
      page: 0,
      pickedCase: null,
      pickedCaseId: null,
      search: '',
      filterUnreadFavorites: false,
    }
  },
  apollo: {
    /*cases: {
      query: CaseListWithMessageCounts,
      fetchPolicy: 'cache-and-network',
      pollInterval: 60000,
      variables(): CaseListWithMessageCountsQueryVariables {
        return {
          search: this.search,
          stage: this.filterStage,
          first: this.first,
          offset: this.offset,
        }
      },
    },*/
    pickedCase: {
      query: CaseWithMessages,
      fetchPolicy: 'cache-and-network',
      skip(): boolean {
        return this.pickedCaseId === null
      },
      variables(): CaseWithMessagesQueryVariables {
        return {
          id: this.pickedCaseId,
        }
      },
    },
  },
  mounted() {
    window.setTimeout(() => {
      this.updateTimestamp()
    }, 1500)
    this.myMessages = this.$store.getters['myMessages/storedObjectsArray']
    this.$store.subscribeAction((action, state) => {
      console.log(action.type)
      console.log(action.payload)
      console.log(state)
      if (action.type == 'myMessages/pullObject') {
        this.myMessages = this.$store.getters['myMessages/storedObjectsArray']
      }
    })
  },
  computed: {
    first(): number {
      return this.pageSize
    },
    offset(): number {
      return this.page * this.pageSize
    },
    pageIsLast() : boolean {
      return this.pageMessages.length < (this.page + 1) * this.pageSize
    },
    pageIsFirst() : boolean {
      return this.page === 0
    },
    isInvolved(): boolean {
      return !!this.pickedCase?.me
    },
    isFavorite() : boolean {
      return this.pickedCase?.myInvolvement?.favoriteMessage || false
    },
    favoriteActive(): string {
      if (this.isFavorite) {
        return 'active'
      } else {
        return 'inactive'
      }
    },
    isPatient(): boolean {
      return !!this.pickedCase?.me?.actsAsPatient
    },
    editableMessagesByDate(): MessageNodeFragment[] {
      return orderBy(this.editableMessages, 'createdAt', 'desc')
    },
    addressableRoles(): AddressableRoles {
      const members = this.pickedCase?.members.nodes || []
      return members.reduce(
        (object, source) => ({
          interviewers: object.interviewers || source.actsAsInterviewer,
          patients: object.patients || source.actsAsPatient,
          supervisors: object.supervisors || source.actsAsSupervisor,
          supporters: object.supporters || source.actsAsSupporter,
          therapists: object.therapists || source.actsAsTherapist,
          counselors: object.counselors || source.actsAsCounselor,
        }),
        {} as AddressableRoles
      )
    },
    leastEditableMessage(): MessageNodeFragment {
      if (this.editableMessagesByDate.length > 0){
        return this.editableMessagesByDate[0]
      }
      return null
    },
    favoriteTitle(): string {
      if (this.isFavorite) {
        return 'unset favorite'
      } else {
        return 'set favorite'
      }
    },
    pageMessages() {
      let messages = this.myMessages
      var tmpMessages = new Array()
      if (this.search != null && this.search != '') {
        messages = messages.filter(
          element =>
            element.id
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            element.alias.toLowerCase().includes(this.search.toLowerCase()) ||
            element.short_id
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            element.username?.toLowerCase()?.includes(this.search.toLowerCase()) ||
            element.email?.toLowerCase()?.includes(this.search.toLowerCase())
        )
      }

      if (this.filterStage != '') {
        messages = messages.filter(
          (element: { stage: string }) => element.stage === this.filterStage
        )
      }

      if (this.filterUnreadFavorites) {
        messages = messages.filter(
          (element: { countmessages: number; favorite_message: boolean }) =>
            element.countmessages > 0 || element.favorite_message
        )
      }

      if (messages.length > this.page * this.pageSize) {
        for (
          var i = this.page * this.pageSize;
          i < Math.min(this.page * this.pageSize + this.pageSize, messages.length);
          i++
        ) {
          tmpMessages.push(messages[i])
        }
      }
      return tmpMessages
    },
  },
  methods: {
    nextPage(): void {
      this.page++
    },
    previousPage(): void {
      this.page = Math.max(0, this.page - 1)
    },
    async updateTimestamp() {
      if (!this.pickedCase?.myInvolvement?.id) {
        return
      }

      const variables: UpdateNewMessagesOfterOfInvolvementMutationVariables = {
        id: this.pickedCase.myInvolvement.id,
        after: new Date(),
      }

      await this.$apollo.mutate({
        mutation: UpdateNewMessagesOfterOfInvolvement,
        variables,
      })

      //this.$apollo.queries.cases.refetch()
    },
    setFavorite() {
      this.pickedCase.myInvolvement.favoriteMessage = !this.pickedCase.myInvolvement.favoriteMessage
      let message = this.pageMessages.find(element => element.id == this.pickedCaseId)
      if (message != null) {
        message.favorite_message = !message.favorite_message
      }

      this.updateFavoriteMessage()
    },
    async updateFavoriteMessage() {
      if (!this.pickedCase?.myInvolvement?.id) {
        return
      }

      const variables: UpdateFavoriteMessageMutationVariables = {
        id: this.pickedCase.myInvolvement.id,
        favoriteMessage: this.pickedCase.myInvolvement.favoriteMessage,
      }

      await this.$apollo.mutate({
        mutation: UpdateFavoriteMessageOfInvolvement,
        variables,
      })
    },
    async addMessage() {
      if (!this.isInvolved) {
        window.alert("you're not involved in this case!")
        return
      }
      await this.$store.dispatch({ type: 'messages/addMessage', inCase: this.pickedCase })
      this.$apollo.queries.pickedCase.refetch()
    },
    renderMarkdown(code: string): string {
      return marked(code)
    },
    async drop(message: MessageNodeFragment) {
      if (!window.confirm('sure to delete this message?')) {
        return
      }
      await this.$apollo.mutate({
        mutation: DeleteCaseMessageById,
        variables: {
          id: message.id,
        },
      })
      Vue.delete(this.editableMessages, message.id)
    },
    canSend(message: MessageNodeFragment): boolean {
      return (
        !!message.body &&
        message.body.length > 0 &&
        (!!message.toInterviewers ||
          !!message.toTherapists ||
          !!message.toPatients ||
          !!message.toSupervisors ||
          !!message.toSupporters ||
          !!message.toCounselors)
      )
    },
    async save(message: MessageNodeFragment, send: boolean = false) {
      if (send && !window.confirm('sure to send this message?')) {
        return
      }

      const now = new Date()
      console.debug('save message', message)

      const variables: UpdateCaseMessageMutationVariables = {
        id: message.id,
        patch: {
          body: message.body,
          updatedAt: now,
          toSupporters: message.toSupporters,
          toTherapists: message.toTherapists,
          toPatients: message.toPatients,
          toInterviewers: message.toInterviewers,
          toSupervisors: message.toSupervisors,
          toCounselors: message.toCounselors,
          sentAt: send ? now : null,
        },
      }

      console.debug('save variables', variables)

      await this.$apollo.mutate({
        mutation: UpdateCaseMessageById,
        variables,
      })

      if (send) {
        Vue.delete(this.editableMessages, message.id)
        this.$apollo.queries.pickedCase.refetch()
      }

      this.updateTimestamp()
    },
    resetReceipant: function() {
      this.leastEditableMessage.toInterviewers = false
      this.leastEditableMessage.toCounselors = false
      this.leastEditableMessage.toTherapists = false
      this.leastEditableMessage.toSupporters = false
    }
  },
  watch: {
    pickedCase: {
      deep: false,
      handler(newCase: PickedCase | null, oldCase: PickedCase | null) {
        if (!newCase) {
          this.editableMessages = {}
        } else {
          const keyedMessages = keyBy(cloneDeep(newCase.unsentMessages.nodes), 'id')
          this.updateTimestamp()
          // same case, add missing messages
          if (newCase.id === oldCase?.id) {
            for (let id in keyedMessages) {
              if (!this.editableMessages[id]) {
                Vue.set(this.editableMessages, id, keyedMessages[id])
              }
            }
          }
          // different case, swap messsages
          else {
            this.editableMessages = keyedMessages
          }
        }
      },
    },
    selectedTarget: function(val) {
      switch (val) {
        case "therapists":
          this.resetReceipant()
          this.leastEditableMessage.toTherapists = true
          break
        case "interviewers":
          this.resetReceipant()
          this.leastEditableMessage.toInterviewers = true
          break
        case "supporters":
          this.resetReceipant()
          this.leastEditableMessage.toSupporters = true
          break
        case "counselors":
          this.resetReceipant()
          this.leastEditableMessage.toCounselors = true
          break
      }
    },
    search() {
      this.page = 0
    },
    selectedStage() {
      this.page = 0
    },
    filterUnreadFavorites() {
      this.page = 0
    },
    myMessages() {
      if (this.myMessages.length === 1) {
        this.pickedCaseId = this.myMessages[0].id
      } else if (!this.myMessages || this.myMessages.length === 0) {
        this.pickedCaseId = null
        this.pickedCase = null
      }
    },
    'cases.nodes'(newList: ShortCase[]) {
      if (newList.length === 1) {
        this.pickedCaseId = newList[0].id
      } else if (!newList || newList.length === 0) {
        this.pickedCaseId = null
        this.pickedCase = null
      }
    },
    currentCase(newCase, oldCase) {
      if (newCase && oldCase && newCase.id !== oldCase.id) {
        this.$store.dispatch({ type: 'messages/updateTimestamp', inCase: newCase })
      }
    },
  },
})
